import axios from 'axios'
import Constants from '../constants'

export default {
  getAnalytics: (event, action) => {
    return new Promise((resolve, reject) => {
    const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      const params = {
        id: Constants.API_ID,
        areaId: Constants.API_ID,
        env: env_key,
        event: event,
        action: action
      }

      axios.get('analytics', { params })
        .then(() => {
          resolve()
        })
        .catch(() =>  reject())
    })
  }
}
